export function getAnalyticsPath() {
  const DOMAIN = 'https://assets.adobedtm.com';
  const DEVELOPMENT = `${DOMAIN}/6e420e4d1161/37d59210201b/launch-e74bd04d8b6c-development.min.js`;
  const STAGING = `${DOMAIN}/6e420e4d1161/37d59210201b/launch-2f33143d161d-staging.min.js`;
  const PRODUCTION = `${DOMAIN}/6e420e4d1161/37d59210201b/launch-e57425ae8cd9.min.js`;
  const { hostname } = window.location;
  if (hostname.includes('localhost')) {
    return DEVELOPMENT;
  } else if (
    hostname.includes('.int3') ||
    hostname.includes('.sit6') ||
    hostname.includes('.tat')
  ) {
    return STAGING;
  } else {
    return PRODUCTION;
  }
}
